module.exports = __webpack_public_path__ + "img/IMG_9699_1.6f8eb0a5.jpeg";